module.exports = __webpack_public_path__ + "img/Amex3.09b5c07b.svg";